import styleService from '@nykaa/deals-utils/styles';
import styled from '../../theme';
const { getFontStyles, getMarginStyles, getPaddingStyles, getBKGStyles, getBorderStyles, getIndividualBorderRadius, getIndividualBorder, } = styleService.utils;
const logoAlignStyle = (alignment) => {
    switch (alignment) {
        case 'top':
            return (`
        left: 0;
        top:0;
        right:0;
        margin:auto;
      `);
        case 'top_left':
            return (`
        left: 0;
        top:0;
        margin:auto;
      `);
        case 'below':
            return (`
        display:none;
      `);
        default:
            return (`
        left: 0;
        top:0;
        bottom:0;
        margin:auto;
      `);
    }
};
export const getTagPosition = (position) => {
    switch (position) {
        case 'center':
            return (`
       justify-content: center;
      `);
        case 'right':
            return (`
      justify-content: flex-end;
      `);
        default:
            return (`
      justify-content: flex-start;
      `);
    }
};
const bottomLogoDisplayStyle = (alignment) => {
    switch (alignment) {
        case 'below':
            return (`
        display: block;
      `);
        default:
            return (`
        display: none;
      `);
    }
};
export const Wrapper = styled.div `
  text-decoration: none;
  color: inherit;
  display: block;
  background: trasparent;
  padding-bottom:  ${({ bannerCss }) => bannerCss.spacingStyle.interItem.web};
  padding-left: 0;
  padding-right:0;

  &.inside{
    padding: 27px 27px;
    border: 2px solid red;
  }
  
`;
export const TextAreaWrapper = styled.div `
  cursor: pointer;
  ${({ styleTextarea, isNewTemplate }) => isNewTemplate && getIndividualBorder(styleTextarea.individualBorders)};
  ${({ styleTextarea, isNewTemplate }) => isNewTemplate && getIndividualBorderRadius(styleTextarea.individualCornerRadius)};
  ${({ styleTextarea }) => getBKGStyles(styleTextarea.bkg)};
  ${({ styleTextarea }) => getPaddingStyles(styleTextarea.padding)};
  ${({ styleTextarea }) => getMarginStyles(styleTextarea.margin)};
`;
export const ContentWrapper = styled.div `
  width: auto;
  position: relative;
  .tag-text-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    width: fill-available;
    ${({ bannerCss }) => getTagPosition(bannerCss.childTagStyle.tagPosition)};
    ${({ bannerCss }) => getMarginStyles(bannerCss.childTagStyle.margin)};
  }
  .tag-text-visible {
    display: none;
  }
  .tag-type-text {
    ${({ bannerCss }) => getBKGStyles(bannerCss.childTagStyle.bkg)};
    ${({ bannerCss }) => getPaddingStyles(bannerCss.childTagStyle.padding)};
    ${({ bannerCss }) => getFontStyles(bannerCss.childTagStyle.text)};
    ${({ bannerCss }) => getBorderStyles(bannerCss.childTagStyle.border)};
    border-radius: ${({ bannerCss }) => bannerCss.childTagStyle.cornerRadius.web};
    .tag-text, .color-tag {
      float:left;
      ${({ bannerCss }) => (bannerCss.childTagStyle.timerAlignment === 'right' && `
        float:left;
      `)};
      ${({ bannerCss }) => (bannerCss.childTagStyle.timerAlignment === 'left' && `
        float:right;
      `)};
      display: -webkit-box;
      -webkit-line-clamp: ${({ bannerCss }) => bannerCss.childTagStyle.text.maxLines.web};
      -webkit-box-orient: vertical;
      overflow: hidden;
      ${({ bannerCss }) => getFontStyles(bannerCss.childTagStyle.text)};
    }
    .tag-timer-text {
      ${({ bannerCss }) => getFontStyles(bannerCss.childTagStyle.textTimer)};
      min-width: 48px;
      float:${({ bannerCss }) => bannerCss.childTagStyle.text.alignment};
      padding: 0px 1px;
      display: -webkit-box;
      -webkit-line-clamp: ${({ bannerCss }) => bannerCss.childTagStyle.text.maxLines.web};
      -webkit-box-orient: vertical;
      overflow: hidden;
      padding-left:  ${({ bannerCss }) => bannerCss.childTagStyle.timerAlignment === 'right' && '4px'};
      padding-right:  ${({ bannerCss }) => bannerCss.childTagStyle.timerAlignment === 'left' && '4px'};
    }

    }
    .tag-type-text.empty {
      display: none ;
    }
    .image-tag-wrapper { 
      position: relative;
      overflow: hidden;
      cursor: pointer;    
      ${({ bannerCss, isNewTemplate }) => { var _a; return (isNewTemplate ? getIndividualBorderRadius((_a = bannerCss === null || bannerCss === void 0 ? void 0 : bannerCss.childBannerStyle) === null || _a === void 0 ? void 0 : _a.individualCornerRadius) : `border-radius: ${bannerCss.childBannerStyle.cornerRadius.web} !important`); }};  
      .outline-wrapper {
        position: absolute;
        left: 0;
        top: 0;
        width: fill-available;
        height: fill-available;
        ${({ bannerCss, isNewTemplate }) => { var _a; return (isNewTemplate ? getIndividualBorderRadius((_a = bannerCss === null || bannerCss === void 0 ? void 0 : bannerCss.childBannerStyle) === null || _a === void 0 ? void 0 : _a.individualCornerRadius) : `border-radius: ${bannerCss.childBannerStyle.cornerRadius.web} !important`); }};
        outline: ${({ bannerCss, isNewTemplate }) => (isNewTemplate && `${bannerCss.childBannerStyle.border.width.web}  solid ${bannerCss.childBannerStyle.border.color}`)};
        outline-offset: ${({ bannerCss, isNewTemplate }) => (isNewTemplate && `-${bannerCss.childBannerStyle.border.width.web}`)};
        border: ${({ bannerCss, isNewTemplate }) => (!(isNewTemplate) && `${bannerCss.childBannerStyle.border.width.web}  solid ${bannerCss.childBannerStyle.border.color}`)};  
      }
    }
    .image-container {
      cursor: pointer;
      min-height: 50px;
      .card-view
      {}
      .image-with-logo {
      .image-wrapper:nth-of-type(2)
      {
        border-radius: ${({ bannerCss }) => bannerCss.childLogoStyle.cornerRadius.web};
        position: absolute;
        ${({ bannerCss }) => logoAlignStyle(bannerCss.childLogoStyle.alignment)};
        width: ${({ bannerCss }) => bannerCss.childLogoStyle.width}%;
        height: ${({ bannerCss }) => parseInt(bannerCss.childLogoStyle.width, 10) / 1.5}%;
        background: #fff;
        z-index: 999;
        ${({ bannerCss }) => getPaddingStyles(bannerCss.childLogoStyle.padding)};
      }
    }

    .callout-radius {
      border-radius: 0px 0px ${({ bannerCss, isNewTemplate }) => { var _a; return (isNewTemplate ? (_a = bannerCss.childBannerStyle.individualCornerRadius.bottomRight) === null || _a === void 0 ? void 0 : _a.web : bannerCss.childBannerStyle.cornerRadius.web); }}  ${({ bannerCss, isNewTemplate }) => (isNewTemplate ? bannerCss.childBannerStyle.individualCornerRadius.bottomLeft.web : bannerCss.childBannerStyle.cornerRadius.web)};
    }
  }`;
export const CalloutWrapper = styled.div `
    width: auto;
    ${({ cssCallout }) => getBKGStyles(cssCallout.bkg)};
    ${({ cssCallout }) => getPaddingStyles(cssCallout.padding)};
    ${({ cssCallout }) => getFontStyles(cssCallout.textCallout1 ? cssCallout.textCallout1 : cssCallout.text)};
    position:absolute;
    bottom:0;
    left:0;
    right:0;
    
    .callout-text
    {
      display: -webkit-box;
      -webkit-line-clamp:  ${({ cssCallout }) => (cssCallout.textCallout1 ? cssCallout.textCallout1.maxLines.web : cssCallout.text.maxLines.web)};
      -webkit-box-orient: vertical;
      overflow: hidden;

      ${({ callout2, callout3 }) => ((callout2 && callout3) && `
        padding-bottom: 0;
      `)};

       ${({ callout }) => ((callout) && `
       padding-bottom: 0px;
       `)};

       ${({ callout, callout2, cssCallout }) => ((callout && callout2) && `
       padding-bottom: ${(cssCallout.interItem1 ? cssCallout.interItem1.web : 0)};`)};
       
       ${({ callout, callout2, cssCallout, isDesktop, }) => ((callout && callout2 && isDesktop) && `
       padding-bottom: ${(cssCallout.interItem1 ? cssCallout.interItem1.desktop : 0)};`)};

       ${({ callout, callout3, cssCallout }) => ((callout && callout3) && `
       padding-bottom: ${(cssCallout.interItem1 ? cssCallout.interItem1.web : 0)};`)};
       
       ${({ callout, callout3, cssCallout, isDesktop, }) => ((callout && callout3 && isDesktop) && `
       padding-bottom: ${(cssCallout.interItem1 ? cssCallout.interItem1.desktop : 0)};`)};


    };
    
  };
    .callout-text2{
      color:${({ cssCallout }) => (cssCallout.textCallout2 ? cssCallout.textCallout2.color : cssCallout.text.color)};
      ${({ cssCallout }) => getFontStyles(cssCallout.textCallout2 ? cssCallout.textCallout2 : cssCallout.text)};
      display: -webkit-box;
      -webkit-line-clamp:  ${({ cssCallout }) => (cssCallout.textCallout2 ? cssCallout.textCallout2.maxLines.web : cssCallout.text.maxLines.web)};
      -webkit-box-orient: vertical;
      overflow: hidden;
      ${({ callout, callout2 }) => ((callout && callout2) && `
          padding-bottom: 0;
     `)};
     ${({ callout2 }) => ((callout2) && `
        padding-bottom: 0px;
     `)};

     ${({ callout3, callout2, cssCallout }) => ((callout3 && callout2) && `
     padding-bottom: ${(cssCallout.interItem2 ? cssCallout.interItem2.web : 0)};`)};
     
     ${({ callout3, callout2, cssCallout, isDesktop, }) => ((callout3 && callout2 && isDesktop) && `
     padding-bottom: ${(cssCallout.interItem2 ? cssCallout.interItem2.desktop : 0)};`)};

    }
    .callout-text3{
      color:${({ cssCallout }) => (cssCallout.textCallout3 ? cssCallout.textCallout3.color : cssCallout.text.color)};
      ${({ cssCallout }) => getFontStyles(cssCallout.textCallout3 ? cssCallout.textCallout3 : cssCallout.text)};
      display: -webkit-box;
      -webkit-line-clamp:  ${({ cssCallout }) => (cssCallout.textCallout3 ? cssCallout.textCallout3.maxLines.web : cssCallout.text.maxLines.web)};
      -webkit-box-orient: vertical;
      overflow: hidden;
      
    }
`;
export const BottomLogo = styled.div `
  width: ${({ bannerCss }) => bannerCss.childLogoStyle.width}%;
  height: ${({ bannerCss }) => parseInt(bannerCss.childLogoStyle.width, 10) / 1.5}%;
  background:#fff;
  z-index: 999;
  ${({ bannerCss }) => getPaddingStyles(bannerCss.childLogoStyle.padding)};
  ${({ bannerCss }) => (bottomLogoDisplayStyle(bannerCss.childLogoStyle.alignment))};
`;
export const DetailsWrapper = styled.div `
  ${({ styleTextarea }) => getFontStyles(styleTextarea.childDescriptionStyle.text)};
    
  .titles-description {
    width: 100%;
    position: relative;
    word-wrap: break-word;
  }
  .titles-description-sticky {
    border-radius: 3px;
    background:rgba(255,255,255, ${({ opacity }) => opacity} );
    word-wrap: break-word;
    padding: 5px;
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 20px;
    max-width: 100%;
    width: auto;
    margin-right: 20px;
    margin-left: 20px;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.1);
    bottom: 10px;
    text-transform: capitalize;
  }
  .titles-wrap {
    ${({ styleTextarea }) => getFontStyles(styleTextarea.childTitleStyle.text)};
    ${({ styleTextarea }) => getPaddingStyles(styleTextarea.childTitleStyle.padding)};
    ${({ styleTextarea }) => getMarginStyles(styleTextarea.childTitleStyle.margin)};
    line-height: 1.2;
    .title-text{
      display: inline-block;
      display: -webkit-box;
      -webkit-line-clamp:  ${(props) => props.styleTextarea.childTitleStyle.text.maxLines.web};
      -webkit-box-orient: vertical;
      overflow: hidden;
      
    }
    .discount-text {
      display: inline-block;
      color:  ${(props) => props.theme.brandPrimary};
      margin: 0 4px;
    }
    
  }
  .description {
    ${({ styleTextarea }) => getFontStyles(styleTextarea.childDescriptionStyle.text)};
    ${({ styleTextarea }) => getPaddingStyles(styleTextarea.childDescriptionStyle.padding)};
    display: -webkit-box;
    -webkit-line-clamp:  ${(props) => props.styleTextarea.childDescriptionStyle.text.maxLines.web};
    -webkit-box-orient: vertical;
    overflow: hidden;
    
    @media only screen  and (min-width : 768px) {
      padding-bottom: 0;
    }
  }
`;
